import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';

import {BadgeCountRepo} from '../../../repositories/badge/repo/badge-count-repo';
import {RouteId} from '../../../enums/env/routes-id-enum';
import {RouteIndicatorResponse} from '../../../shared/types/routes/indicator-route.types';

export const tabIndicatorResolver: ResolveFn<RouteIndicatorResponse> = () => {
    const badgeCountRepo = inject(BadgeCountRepo);

    return {
        [RouteId.BADGES_STOCK]: badgeCountRepo.stockCount$,
        [RouteId.BADGES_ABNORMALITIES]: badgeCountRepo.abnormalitiesCount$,
        [RouteId.BADGES_REQUESTS]: badgeCountRepo.requestsCount$,
    }
};


